export const TERTIARY_BTN = 'tertiaryBtn';
export const OUTLINE_BTN = 'outline';
export const BLUELINK_BTN = 'blueLink';
export const PRIMARY_BTN = 'primaryBtn';
export const LIGHT = 'light';
export const DARK = 'dark';
export const PRIMARY = 'primary';
